import React from "react";
import { FormControl, Container, Chip, Flex } from "@airbus/components-react";

//CSS
import "../css/ContactInfo.css";

class ContactInfoView extends React.Component {

    constructor(props){
        super();

        //states
        this.state={
            form:{
                id: props.id,
                name: props.name,                   //Form handler
                firstname: props.firstname,
                mail: props.mail,
                phone: props.phone,
                adresse1: props.adresse1,
                adresse2: props.adresse2,
                postcode: props.postcode,
                city: props.city,
                comment: props.comment,
                subscriptions: props.subscriptions
            },
        }

        
    }
    

    /**
     * RENDERING
     * @returns dom
     */
     render() {

        return(
            <Container>

                
                {/*NAME*/}
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="controlForm"
                    label="Nom"
                >
                    <div>{this.state.form.name}</div>
                    
                </FormControl>

                {/*FIRST NAME*/}
                <FormControl
                    className="controlForm"
                    label="Prénom"
                >
                    <div>{this.state.form.firstname}</div>
                </FormControl>

                {/*MAIL*/}
                <FormControl
                    className="controlForm"
                    label="Mail"
                >
                    <div>{this.state.form.mail}</div>
                </FormControl>

                {/*PHONE*/}
                <FormControl
                    className="controlForm"
                    label="Téléphone"
                >
                    <div>{this.state.form.phone}</div>
                </FormControl>
                </Flex>

                {/*ADRESSE*/}
                <Container until="md" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex justify="start" wrap={true} direction="row" >
                <FormControl
                    className="FullWidthcontrolForm"
                    label="Adresse"
                >
                    <div>{this.state.form.adresse1}</div>
                </FormControl>
                </Flex>
                </Container>

                <Container until="md" className="container-left" style={{paddingLeft:"0px", paddingTop:"10px"}}>
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="FullWidthcontrolForm"
                >
                    <div>{this.state.form.adresse2}</div>
                </FormControl>
                </Flex>
                </Container>

                {/*Code Postal*/}
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="controlForm"
                    label="Code postal"
                >
                    <div>{this.state.form.postcode}</div>
                </FormControl>

                {/*City*/}
                <FormControl
                    className="controlForm"
                    label="Ville"
                >
                    <div>{this.state.form.city}</div>
                </FormControl>

                </Flex>

                {/*Commentaires*/}
                <Container until="md" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex wrap={true} direction="row" >
                <FormControl
                    className="FullWidthcontrolForm"
                    label="Commentaires"
                    style={{width:772}}
                >
                    <div>{this.state.form.comment}</div>
                </FormControl>
                </Flex>
                </Container>

                <Flex wrap={true} direction="row" >
                <FormControl
                    className="FullWidthcontrolForm"
                    label="Abonnements"
                >
                    <Flex wrap={true} direction="row" >
                    {this.state.form.subscriptions.map((item, i)=>(
                        <div 
                            style={i===0 ? {paddingTop:'5px'}: {paddingLeft: '5px', paddingTop:'5px'}}
                        >
                                
                        <Chip
                            variant="info" 
                            label={item.category} 
                            size="xsmall"
                        />
                        </div>
                    ))}
                    </Flex>
                </FormControl>
                </Flex>


            </Container>


        )}
    

      
    


}

export default ContactInfoView;